var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.posts),function(post,index){return (index < 10)?_c('li',{key:index},[_c('router-link',{staticClass:"d-block",attrs:{"to":'#'}},[_vm._v(_vm._s(post.title))]),_c('span',{staticClass:"cate"},[_vm._v(_vm._s(post.categories[0]))])],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }